<template>
  <div>
    <b-container>
      <Form :tipoMaterial="tipoMaterial" />
    </b-container>
  </div>
</template>

<script>
import Form from './Form';

export default {
  components: {
    Form,
  },
  props: {
    tipoMaterial: {
      type: String,
    },
  },
};
</script>
